/**
 * The colour the phone paints its status bar and browser chrome with: the
 * app's `--background` in each theme, so the bar reads as part of the page.
 * `index.html` carries the same two values for the paint before React runs.
 */
export const THEME_COLORS = {
  light: "#ffffff",
  dark: "#020817",
} as const;

/**
 * Points every `theme-color` meta at the theme the app resolved to. The tags in
 * `index.html` follow the OS scheme; a theme picked in the app overrides it.
 */
export function syncThemeColor(theme: keyof typeof THEME_COLORS): void {
  document
    .querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')
    .forEach((meta) => {
      meta.content = THEME_COLORS[theme];
    });
}
